export enum DiscountType {
  priceReductionCampaign = 'priceReductionCampaign',
}
